import IconButton, { type IconButtonProps } from '@mui/material/IconButton';

import { IconX as CloseIcon } from '@/components/icon/tabler/IconX';

type Props = Omit<IconButtonProps, 'children'>;

/**
 * Signal close control shared by Modal and Drawer: 32px, tinted gray tile
 * (`rounded-default` → `#F0EDF4`), no border.
 */
export default function OverlayCloseButton(props: Props) {
  return (
    <IconButton color="rounded-default" size="small" {...props}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );
}
